import React from 'react'
import moment from 'moment'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import MomentLocaleUtils, {formatDate, parseDate} from 'react-day-picker/moment'
import 'moment/locale/ro'

export default class DatePicker extends React.Component {

    constructor(props) {
        super(props)
        const date = this.props.date || (this.props.allow_blank ? undefined :  new Date())
        this.state = {
            locale: 'ro',
            date: date ? moment(date).toDate() : undefined,
            hiddenDate: date ? `${formatDate(date, 'YYYY-MM-DD')}` : ''
        }
        moment.locale(this.state.locale)
    }

    handleDayChange = day => {
        this.setState({
            date: day,
            hiddenDate: day ? `${formatDate(day, 'YYYY-MM-DD')}` : ''
        })
    }

    render() {
        let dayPickerProps = {
            locale: this.state.locale,
            localeUtils: MomentLocaleUtils,
        }
        if(!this.props.noDisabledDays)
            dayPickerProps = Object.assign(dayPickerProps, {disabledDays: {before: new Date()}})
        if(this.props.min_date && this.props.max_date)
            dayPickerProps = Object.assign(dayPickerProps, {disabledDays: {before: new Date(this.props.min_date), after: new Date(this.props.max_date)}})
        return (
            <div>
                <input type="hidden" name={this.props.field_name} id={this.props.field_id} value={this.state.hiddenDate}/>
                <DayPickerInput inputProps={{className: "form-control"}}
                    onDayChange={this.handleDayChange}
                    month={this.state.date}
                    fromMonth={moment().toDate()}
                    selectedDays={this.state.date}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    format="LL"
                    value={ this.state.date && `${formatDate(this.state.date, 'LL', this.state.locale)}` }
                    placeholder='Selecteaza data'
                    dayPickerProps= {dayPickerProps}
                    />
            </div>
        )
    }
}